import { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { Button as AntdButton } from 'antd'

const Button = forwardRef((props, ref) => {
  const {
    type,
    htmlType,
    href,
    target,
    shape,
    icon,
    className,
    style,
    loading = false,
    disabled = false,
    onClick,
    // Opt-in test ID for E2E locators. React omits the attribute when this is
    // undefined, so existing call sites are unaffected.
    testId,
  } = props

  return (
    <AntdButton
      ref={ref}
      data-testid={testId}
      type={type ? type : 'default'}
      {...(htmlType ? { htmlType } : {})}
      {...(href ? { href } : {})}
      {...(target ? { target } : {})}
      {...(shape ? { shape } : {})}
      icon={icon}
      className={className}
      style={style}
      loading={loading}
      disabled={disabled}
      {...(onClick ? { onClick } : {})}
    >
      {props.children}
    </AntdButton>
  )
})

Button.displayName = 'Button'
Button.propTypes = {
  type: PropTypes.string,
  htmlType: PropTypes.string,
  href: PropTypes.string,
  target: PropTypes.string,
  shape: PropTypes.string,
  icon: PropTypes.element,
  className: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  testId: PropTypes.string,
}

export default Button
